import React, { FC, ReactNode, Fragment } from 'react';
import { Container, Grid, Hidden, makeStyles, Theme } from '@material-ui/core';
import { SpacingLayout } from 'components/atoms';
import { FeatureItem } from 'templates/carrier';
import { FeatureItemProps } from 'templates/carrier/FeatureItem';

interface FeatureSectionProps {
  bgImage: ReactNode;
  featuresList: Array<Pick<FeatureItemProps, Exclude<keyof FeatureItemProps, 'animationDelay'>>>;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    position: 'relative',
  },
  bgWrapper: {
    position: 'absolute',
    zIndex: -1,
    top: '-1%',
    left: '24%',
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      top: '-18%',
      left: '23%',
    },
  },
  gridItem: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(10),
    },
    [theme.breakpoints.up('md')]: {
      '&:not(:last-child)': {
        marginBottom: 0,
      },
      '&:not(:nth-last-child(-n+2))': {
        marginBottom: theme.spacing(12),
      },
    },
  },
}));

const FeatureSection: FC<FeatureSectionProps> = ({ bgImage, featuresList }) => {
  const classes = useStyles();

  return (
    <>
      {!!featuresList.length && (
        <SpacingLayout className={classes.wrapper}>
          <div className={classes.bgWrapper}>{bgImage}</div>
          <Container maxWidth={false} fixed>
            <Grid container spacing={4}>
              {featuresList.map((feature, index) => (
                <Fragment key={index}>
                  <Hidden mdDown smUp={!!(index % 2)}>
                    <Grid item lg={1} />
                  </Hidden>

                  <Grid item md={6} lg={5} className={classes.gridItem}>
                    <FeatureItem
                      title={feature.title}
                      text={feature.text}
                      underText={feature.underText}
                      svgIcon={feature.svgIcon}
                      animationDelay={(index + 1) * 200}
                    />
                  </Grid>

                  <Hidden mdDown smUp={!(index % 2)}>
                    <Grid item lg={1} />
                  </Hidden>
                </Fragment>
              ))}
            </Grid>
          </Container>
        </SpacingLayout>
      )}
    </>
  );
};

export default FeatureSection;
